// extracted by mini-css-extract-plugin
export default {"headerWrapper":"TeMtxjCM","headerButton":"muwwTpqN","root":"qZceK6W4","tabs":"xqCtDG8f","tabsOverlay":"lEWjaIlo","tab":"hz6JlkPz","menuWrapper":"n8wPoS59"};